function timedqueue(timeout) {
  this.seq = 0;
  this.timeout = timeout || 1000;
}
timedqueue.prototype = [];

timedqueue.prototype.clear = function () {
  this.length = 0;
};

timedqueue.prototype.prune = function () {
  for (
    var i = 0, length = this.length, now = Date.now();
    i < length && this[i].expires < now;
    ++i
  );
  this.splice(0, i);
};

timedqueue.prototype.enqueue = function (cmd) {
  this.prune();
  cmd.expires = Date.now() + this.timeout;
  cmd.seq = cmd.seq || ++this.seq;
  this.push(cmd);
  return cmd.seq;
};

// overrides native Array.prototype.find but retains its functionality if first
// param is a function
timedqueue.prototype.find = function (name_or_seq, type, id) {
  this.prune();
  var i = this.length;
  var cmd;
  switch (typeof name_or_seq) {
  case 'function':
    Array.prototype.find.apply(this, arguments);
    break;
  case 'number':
    while (i--) {
      cmd = this[i];
      if (cmd.seq === name_or_seq)
        return cmd;
    }
    break;
  case 'string':
  default:
    while (i--) {
      cmd = this[i];
      if (cmd.name === name_or_seq && cmd.type === type && cmd.id === id)
        return cmd;
    }
  }
};


export default timedqueue;
